import React, { ReactElement } from "react";

import "./TFoot.scss";

interface TFootProps {
  content: ReactElement;
}

export const TFoot = ({ content }: TFootProps) => {
  return (
    <div role="rowgroup" className="tfoot">
      <div role="row" className="tr">
        <div role="cell" className="td">
          {content}
        </div>
      </div>
    </div>
  );
};
